import {tns} from 'tiny-slider/src/tiny-slider'
import $ from 'jquery'
import {updateWishlistIconsFor$Element} from "@MAIN/app/modules/AddToWishListButton";
import {handleAddToCartButtonsFor$Element} from "@MAIN/app/modules/AddToCartButton";

if (window.JS_PAGE === 'INDEX') {
  if (document.getElementsByClassName('js-index-banners__slider').length) {
    const slider = tns({
      container: '.js-index-banners__slider',
      items: 1,
      mode: 'gallery',
      slideBy: 'page',
      navPosition: 'bottom',
      mouseDrag: false,
      autoHeight: true,
      autoWidth: false,
      autoplay: true,
      autoplayTimeout: 10000,
      animateIn: 'tns-fadeIn',
      animateOut: 'tns-fadeOut',
      animateNormal: 'tns-normal',
      arrowKeys: true,
      prevButton : '.index-banners__arrow--left',
      nextButton : '.index-banners__arrow--right',
      autoplayButtonOutput: false,
      disable: true,

      responsive: {
        576: {
          disable: false,
          autoHeight: false,
          autoplay: true,
          autoplayHoverPause: true,
          autoplayTimeout: 6000,
        },
      },
    })

    slider.events.on('newBreakpointEnd', (info, eventName) => slider.updateSliderHeight() );
  }

  if (document.getElementsByClassName('index-store__cats').length) {
    const categoriesProductsEl = document.querySelectorAll('.index-store__products')
    ;[...categoriesProductsEl].forEach(el => {
      tns({
        container: el,
        items: 2,
        gutter: 0,
        autoWidth: false,
        slideBy: 'page',
        nav: true,
        navPosition: 'bottom',
        controls: false,
        loop: false,
        rewind: false,
        center: false,
        prevButton : el.parentElement.querySelector('.index-store__products-arrow--left'),
        nextButton : el.parentElement.querySelector('.index-store__products-arrow--right'),

        responsive: {
          768: {
            items: 3,
          },
          992: {
            items: 4,
            nav: false,
            controls: true,
          },
        },
      })
    })
  }

  if (document.getElementsByClassName('index-history__slider').length) {
    tns({
      container: '.index-history__slider',
      items: 1,
      slideBy: 1,
      mode: 'gallery',
      nav: false,
      controlsText: [null, null],
      prevButton : '.index-history__slider-arrow--left',
      nextButton : '.index-history__slider-arrow--right',
      gutter: 0,
    })
  }

  if (document.getElementsByClassName('index-promo__slider').length) {
    tns({
      container: '.index-promo__slider',
      items: 1,
      slideBy: 1,
      nav: false,
      controlsText: [null, null],
      prevButton : '.index-promo__arrow--left',
      nextButton : '.index-promo__arrow--right',
      gutter: 50,
      autoHeight : true,
    })
  }
}
